import React from 'react';
import { graphql, compose } from 'react-apollo';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import CSVReader from 'react-csv-reader';

import messages from '../../../locale/messages';
import languageCatalogQuery from './languageCatalog.graphql';
import uploadLanguageCatalogMutation from './uploadLanguageCatalog.graphql';
import importIcon from '/public/AdminIcons/adminImportIcon.svg';
import csvIcon from '/public/AdminIcons/uploadCSV.svg';
import cs from '../../commonStyle.css';
import s from './LanguageManagement.css';

class LanguageManagement extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      uploading: false,
      summary: '',
      errors: [],
    };
    this.handleUpload = this.handleUpload.bind(this);
  }

  async handleUpload(rows) {
    const { uploadCatalog, versionData, intl: { formatMessage } } = this.props;
    this.setState({ uploading: true, summary: '', errors: [] });

    try {
      const { data } = await uploadCatalog({
        variables: { csvValue: rows },
      });
      const result = data && data.uploadLanguageCatalog;
      if (!result) {
        this.setState({
          uploading: false,
          summary: formatMessage(messages.languageUploadUnchanged, { version: 0 }),
          errors: [],
        });
        return;
      }

      const rowErrors = result.errors || [];
      let summary;
      if (result.status !== 200 && rowErrors.length === 0) {
        summary = result.errorMessage;
      } else if (result.changed > 0) {
        summary = formatMessage(messages.languageUploadChanged, {
          count: result.changed,
          version: result.version,
        });
      } else {
        summary = formatMessage(messages.languageUploadUnchanged, { version: result.version });
      }

      this.setState({
        uploading: false,
        summary,
        errors: rowErrors,
      });

      if (versionData && versionData.refetch) {
        versionData.refetch();
      }
    } catch (error) {
      this.setState({
        uploading: false,
        summary: error && error.message ? error.message : 'Upload failed',
        errors: [],
      });
    }
  }

  render() {
    const { versionData, intl: { formatMessage } } = this.props;
    const { uploading, summary, errors } = this.state;
    const version = versionData
      && versionData.languageCatalog
      && versionData.languageCatalog.version;

    const actionLinkClass = cx(cs.dFlex, cs.commonLinkBorder, cs.noTextDecration, cs.commonContentText, cs.fontWeightMedium, cs.siteLinkColor, cs.textNoWrap);

    return (
      <div className={cx(s.pagecontentWrapper, 'pagecontentWrapperRTL')}>
        <h1 className={cx(cs.commonTotalText, cs.spaceBottom5, cs.fontWeightBold)}>
          {formatMessage(messages.manageLanguages)}
        </h1>
        <p className={cx(cs.commonContentText, cs.spaceBottom2)}>
          <FormattedMessage {...messages.languageCatalogHelp} />
        </p>
        <p className={cx(cs.commonContentText, cs.spaceBottom4)}>
          <FormattedMessage {...messages.languageCatalogVersionLabel} />
          {': '}
          {versionData && versionData.loading ? '…' : version}
        </p>
        <div className={cx(cs.dFlex, cs.alignCenter, s.actions)}>
          <a href="/export-admin-data?type=languages" className={actionLinkClass}>
            <FormattedMessage {...messages.downloadLanguageCatalog} />
            <img src={csvIcon} className={cs.csvImageSpace} alt="" />
          </a>
          {uploading
            ? <span className={actionLinkClass}>
              <FormattedMessage {...messages.uploadLanguageCatalog} />
            </span>
            : <div className={cx('csvFileImport', s.fileImport)}>
              <CSVReader
                onFileLoaded={this.handleUpload}
                parserOptions={{ skipEmptyLines: true }}
                label={
                  <>
                    <span>{formatMessage(messages.uploadLanguageCatalog)}</span>
                    <img src={importIcon} alt="" />
                  </>
                }
              />
            </div>}
        </div>
        {summary ? <p className={cx(cs.commonContentText, cs.spaceTop4)}>{summary}</p> : null}
        {errors && errors.length > 0 ? (
          <ul className={cx(cs.commonContentText, cs.spaceTop2)}>
            {errors.map((error) => (
              <li key={`${error.row}-${error.message}`}>
                {`Row ${error.row}: ${error.message}`}
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    );
  }
}

export default compose(
  injectIntl,
  withStyles(s, cs),
  graphql(languageCatalogQuery, {
    name: 'versionData',
    options: {
      variables: { locale: 'en-US' },
      fetchPolicy: 'network-only',
      ssr: false,
    },
  }),
  graphql(uploadLanguageCatalogMutation, {
    name: 'uploadCatalog',
  }),
)(LanguageManagement);
